$(document)
  .off("submit", ".form")
  .on("submit", ".form", function (event) {
    event.preventDefault();

    if (!$(this).find('[name="id"]').val()) {
      console.error("Missing product ID!");
      return;
    }

    if (!$(this).find('[name="quantity"]').val()) {
      $(this).find('[name="quantity"]').val("1");
    }

    console.log("FormData:", $(this).serialize());

    $.post($(this).attr("action"), $(this).serialize())
      .done((response) => {
        console.log("✅ Success:", response);
        window.location.href = window.location.pathname + "?openCart=1";
      })
      .fail((error) => {
        console.error("❌❌❌ Error:", error);
      });
  });

$(document).ready(function () {
  console.log("openCart: " + getUrlParameter("openCart"));

  if (getUrlParameter("openCart") == "1") {
    const $cartDrawer = $("cart-drawer.drawer");
    if ($cartDrawer.length) {
      console.log("🛒 Opening cart drawer after 3 seconds active...");

      // ✅ Add the 'active' class to open the drawer
      $cartDrawer.addClass("active");

      // ✅ Focus on the cart drawer for better UX
      $cartDrawer.focus();
    }
  }
});
